// extracted by mini-css-extract-plugin
module.exports = {"groupsList":"_2Juu7rtZKPoGzkQn0V9JA1","item":"_2dKLQYsNzCoC9g1FQtModY","dot":"_3Q8emyoVtqMNhitVo2xtA9"};